module.exports = function(successCallback, errorCallback) {
	require.ensure([], function() {
		successCallback(require("!!../../../node_modules/babel-loader/lib/index.js!./Personal.js"));
	}, function() {
		if (errorCallback) errorCallback.apply(this, arguments);
	});
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/split-chunk-loader?lazy!./src/BulkDiscount/Page/Personal.js
// module id = 1280
// module chunks = 58